<template>
  <div></div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export default {
  name: 'BaseMessage',
  props: {
    content: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: false
    }
  },
  methods: {
    formatDate (value) {
      const format = 'HH:mm'
      return dayjs.utc(value).local().format(format)
    },
    getClasses (content) {
      const classes = ['chawgt-webchat-msg']
      if (content.from === 'guest') {
        classes.push('chawgt-webchat-msg-right')
      } else {
        classes.push('chawgt-webchat-msg-left')
      }
      return classes.join(' ')
    },
    getStyle (content) {
      if (content.from === 'guest') {
        return `background: ${this.$store.getters['webchat/color']}`
      }
      return ''
    }
  }
}
</script>
